import { Avatar } from 'baseui/avatar';
import { memo, useEffect, useState } from 'react';
import { useStyles } from '../../../../hooks/useStyles';
import { getS3FileUrlByKey } from '../../../../services/appService';
import { isUnknownDriver } from '../../../../utils/drivers';
import ImageFullScreenPreviewModal from '../../../shared/ImageFullScreenPreviewModal';

type Props = Readonly<{
  size?: string;
  fontSize?: string;
  name: string;
  lastName: string;
  photo?: string;
  thumbnail?: string;
  disableFullScreen?: boolean;
}>;

function FleetDriverAvatar({ lastName, name, photo, size, fontSize, thumbnail, disableFullScreen }: Props) {
  const { theme } = useStyles();
  const [driverPhotoUrl, setDriverPhotoUrl] = useState<string>();
  const [preview, setPreview] = useState(false);
  const hasDisplayData = !!photo && !!driverPhotoUrl;
  const allowFullScreen = hasDisplayData && !disableFullScreen;

  useEffect(() => {
    if (photo) {
      getS3FileUrlByKey(photo).then(({ url }) => {
        setDriverPhotoUrl(url);
      });
    }
  }, [photo]);

  return (
    <>
      <Avatar
        initials={
          isUnknownDriver({ name, lastName })
            ? ''
            : `${name.substring(0, 1).toUpperCase()}${lastName.substring(0, 1).toUpperCase()}`
        }
        size={size}
        src={driverPhotoUrl ?? thumbnail}
        overrides={{
          Root: {
            props: {
              onClick: allowFullScreen
                ? () => {
                    setPreview(true);
                  }
                : undefined,
            },
          },
          Avatar: {
            style: {
              cursor: allowFullScreen ? 'pointer' : undefined,
            },
          },
          Initials: {
            style: {
              fontWeight: '600',
              fontSize: fontSize ?? theme.typography.HeadingSmall.fontSize,
            },
          },
        }}
      />
      {allowFullScreen && (
        <ImageFullScreenPreviewModal
          s3Key={photo}
          source={driverPhotoUrl}
          isOpen={preview}
          onClose={() => setPreview(false)}
        />
      )}
    </>
  );
}

export default memo(FleetDriverAvatar);
